import React from "react";
import "../styles/about.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const About: React.FC = () => {
  return (
    <>
      <header
        className="hero"
        style={{
          backgroundImage: "url(/images/header.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "50vh",
          minHeight: 0,
          overflow: "hidden"
        }}
      >
        <Navbar />
        <div className="hero-content">
          <div className="hero-text">
            <h1>Hakkımızda</h1>
          </div>
        </div>
      </header>
      <section className="about-section">
        <div className="about-container">
          <h2>Vizyonumuz</h2>
          <p>Tim Elektrik Dekorasyon ve Uygulama olarak, güvenilirlik ilkesini her zaman ön planda tutarak müşteri memnuniyetini sağlamak en önemli önceliğimizdir. Yaptığımız her işte kaliteyi ve güveni bir arada sunmayı amaçlıyoruz. Geçmişte başarıyla tamamladığımız projeler, bugün bizi daha güçlü kılarken, yarın da büyümemizi ve gelişmemizi sürdürecek önemli adımlardır. Her projede, sadece işin bitirilmesi değil, aynı zamanda her detayın özenle ele alınması gerektiğine inanıyoruz. Müşterilerimizin beklentilerini aşarak, onların en güvenilir çözüm ortağı olmayı hedefliyoruz. Hem bugün hem de gelecekte, sektördeki en güçlü ve güvenilir markalardan biri olmak için durmaksızın çalışıyoruz.</p>
          <h2>Misyonumuz</h2>
          <p>2005 yılından beri Tim Elektrik Dekorasyon ve Uygulama olarak, müşteri memnuniyetini birinci sıraya koyarak her projeye farklı bir titizlikle yaklaşıyoruz. Elektrik tesisat döşeme ve dekorasyon konularında yılların tecrübesiyle, her türlü ev ve işyeri projesine estetik ve fonksiyonellik katıyoruz. Projelerimizde, temel tasarımdan kısmi tadilatlara kadar her aşama detaylı bir planlama ve uygulama süreciyle gerçekleştirilir. Yenilikçi çözümlerimizle, her zaman müşterilerimizin beklentilerine göre özelleştirilmiş hizmet sunuyoruz. Bugün, her işimizde kaliteyi, güvenilirliği ve estetiği ön planda tutarak, sektörün lider firmalarından biri olma yolunda emin adımlarla ilerliyoruz. Referanslarımız ve başarılarımız, bize duyulan güvenin ve sektöre kattığımız değerlerin en güzel göstergesidir.</p>
        </div>
      </section>
      <section className="cards">
        <div className="card">
          <h3>| İş Teslimi</h3>
          <p>Zamanınızın değerli olduğunun farkındayız. İş planında belirttiğimiz zamanda işimize başlıyor ve taahhüt edilen sürede bitirmeyi hedefliyoruz.</p>
        </div>
        <div className="card">
          <h3>| Teklif Süreci</h3>
          <p>Proje keşif sürecinden sonra çalışmak istediğiniz marka malzemeleri üzerinden sizlere yazılı teklifimizi sunarak çalışmalara başlayabilmek için sizden onay bekleyeceğiz.</p>
        </div>
        <div className="card">
          <h3>| Kazanç</h3>
          <p>Marka seçimi ve proje çizdirme opsiyonu ile gerekli eğitimi almış profesyonel kişiler tarafından yapılan işçilikle kaliteli ve güvenilir hizmet almış olursunuz.</p>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default About; 